import { useSearchParams } from "react-router-dom";

import { FinancePayableListFeaturePage } from "..";

/** 应付清单页面：选中的团放在地址的 itineraryId 上，可以直接打开某个团。 */
export function FinancePayableListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <FinancePayableListFeaturePage
      itineraryId={searchParams.get("itineraryId")}
      onSelectItinerary={(itineraryId) => setSearchParams({ itineraryId })}
    />
  );
}
